export const UPDATE_KILLSWITCHES = 'updateKillswitches';
export const UPDATE_PRODUCT_IMAGES_CTA_ADD_ITEM = 'updateProductImagesCtaAddItem';
export const UPDATE_PRODUCT_IMAGES_CTA_ITEMS_ORDER = 'updateProductImagesCtaItemsOrder';
export const UPDATE_PRODUCT_IMAGES_CTA_ITEMS_LIST_RESET = 'updateProductImagesCtaItemsListReset';
export const UPDATE_PRODUCT_IMAGES_CTA_REMOVE_ITEM = 'updateProductImagesCtaRemoveItem';
export const UPDATE_PRODUCT_IMAGES_CTA_UPDATE_ITEM = 'updateProductImagesCtaUpdateItem';
export const UPDATE_PRODUCT_IMAGES_CTA_UPDATE_DIMENSIONS_ENTRY = 'updateProductImagesCtaUpdateDimensionsEntry';
export const UPDATE_PRODUCT_IMAGES_CTA_UPDATE_ITEMS_HEIGHT = 'updateProductImagesCtaUpdateItemsHeight';
export const UPDATE_PRODUCT_IMAGES_CTA_UPDATE_ITEMS_WIDTH = 'updateProductImagesCtaUpdateItemsWidth';
export const UPDATE_SELECTED_QUANTITY = 'updateSelectedQuantity';
// updateProductImagesCtaUpdateDimensionsEntry
